import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { terraProxyApiClient } from '../../clients/testerClient';
import type { EndpointPreviewReturnDto } from '@terra/shared-contracts-endpoints';

type UseEndpointsPreviewProps = {
  applicationId: string;
  metrics?: boolean;
};

export function useEndpointsPreview({
  applicationId,
  metrics,
}: UseEndpointsPreviewProps): {
  endpoints: EndpointPreviewReturnDto[];
  isLoading: boolean;
} {
  const query = useQuery({
    queryKey: [
      'endpoints-preview',
      applicationId,
      { metrics: metrics === true },
    ],
    queryFn: async (): Promise<EndpointPreviewReturnDto[]> => {
      if (!applicationId) {
        return [];
      }

      const result = await terraProxyApiClient.getEndpointsPreview(
        applicationId,
        metrics ? { metrics: true } : undefined,
      );

      return result?.endpoints || [];
    },
    enabled: !!applicationId,
    staleTime: 30000,
  });

  const endpoints = useMemo(() => query.data ?? [], [query.data]);

  return { endpoints, isLoading: query.isLoading };
}
